import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import parse from 'html-react-parser';
import Button from 'components/generalUI/Button';
import Alert from 'components/generalUI/Alert';
import LoadingModal from 'components/generalUI/LoadingModal';
import PurchaseSteps from 'components/generalUI/PurchaseSteps';
import ImageGallery from 'components/TicketInformation/ImageGallery';
import TicketIncludes from 'components/TicketInformation/TicketIncludes';
import TicketConfigurator from 'components/TicketInformation/TicketConfigurator';
import getTicketDisplayName from 'utils/helpers/getTicketDisplayName';
import useTicketInformationViewModel from './ticketInformation.viewModel';
import styles from './TicketInformation.module.scss';

const TicketInformation: FC = () => {
  const { t } = useTranslation();
  const viewModel = useTicketInformationViewModel();
  const { name, description, images, features, loading, summerSchedule, winterSchedule } =
    viewModel;

  return (
    <div className={styles.Container}>
      <LoadingModal visible={loading} />

      <div className={styles.Header}>
        <Button kind="secondary" className={styles.BackButton} onClick={viewModel.goBack}>
          <LeftOutlined />
          {t('pages.ticketInformation.goBack')}
        </Button>
        <PurchaseSteps total={4} current={1} />
      </div>

      <h1 className={styles.Title}>
        {t('pages.ticketInformation.title', {
          name: getTicketDisplayName(name),
        })}
      </h1>

      <Row justify="center" gutter={[40, 24]} className={styles.Content}>
        <Col xs={22} lg={14}>
          <div className={styles.LeftColumn}>
            <ImageGallery images={images} name={name} />
            <Alert
              title={t('pages.ticketInformation.alertTitle')}
              description={parse(
                t('pages.ticketInformation.alertDescription', {
                  summerAperture: summerSchedule?.aperture,
                  summerClosure: summerSchedule?.closure,
                  winterAperture: winterSchedule?.aperture,
                  winterClosure: winterSchedule?.closure,
                })
              )}
            />
            <div className={styles.Description}>{parse(description || '')}</div>
            <TicketIncludes features={features} />
          </div>
        </Col>
        <Col xs={22} lg={10}>
          <TicketConfigurator {...viewModel} />
        </Col>
      </Row>
    </div>
  );
};

export default TicketInformation;
